export default __webpack_public_path__ + "static/media/shubang.8e104c5d.jpg";